<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="400px"
        transition="slide-y-transition"
        origin="top center"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Drukarki
                </h1>
            </v-card-title>

            <v-card-text>
                <v-container class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-select
                                v-model="printerId"
                                label="Drukarka"
                                :items="printers"
                                item-value="id"
                                item-text="name"
                                no-data-text="Nie znaleziono drukarki"
                                :error-messages="printerIdErrors"
                                outlined
                                dense
                                required
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'PrintersDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        printers: {
            type: Array,
            default: () => []
        },
        deliveryData: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            printerId: null,
        }
    },
    validations() {
        return {
            printerId: {
                required,
            }
        }
    },
    computed: {
        printerIdErrors() {
            const errors = []

            if (!this.$v.printerId.$dirty) return errors
            !this.$v.printerId.required && errors.push('Proszę wybrać drukarkę.')

            return errors
        }
    },
    methods: {
        onSave() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }
            this.$emit('on-save', {printerId: this.printerId, delivery: this.deliveryData})
            this.onClose()
        },
        onClose() {
            this.$v.$reset()
            setTimeout(() => {
                this.printerId = null
            }, 500)

            this.$emit('on-close')
        }
    }
}
</script>

